import { Helmet } from 'react-helmet-async';
import {
    Grid,
    Button,
    Container,
    Stack,
    Typography,
    Card,
    Box,
    Tabs,
    Tab,
} from '@mui/material';
import Iconify from '../../components/iconify';
import { useQuery } from '@apollo/client';
import { GET_PACKAGES, GET_PRODUCTS } from 'src/graphql/queries/packages';
import { useState } from 'react';
import PackageManagement from 'src/sections/@dashboard/packages/PackageManagement';
import ProductManagement from 'src/sections/@dashboard/packages/ProductManagement';

function TabPanel({ children, value, index }) {
    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
        </div>
    );
}

export default function AdminPackages() {
    const [tabValue, setTabValue] = useState(0);
    const { data: packagesData, loading: packagesLoading, refetch: refetchPackages } = useQuery(GET_PACKAGES);
    const { data: productsData, loading: productsLoading, refetch: refetchProducts } = useQuery(GET_PRODUCTS);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <>
            <Helmet>
                <title>Package Management | BeeBot Admin</title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Package & Product Management
                    </Typography>
                </Stack>

                <Card>
                    <Tabs value={tabValue} onChange={handleTabChange} aria-label="package management tabs">
                        <Tab label="Packages" icon={<Iconify icon="eva:cube-outline" />} iconPosition="start" />
                        <Tab label="Products" icon={<Iconify icon="eva:shopping-bag-outline" />} iconPosition="start" />
                    </Tabs>

                    <TabPanel value={tabValue} index={0}>
                        <PackageManagement
                            packages={packagesData?.getPackages || []}
                            products={productsData?.getProducts || []}
                            loading={packagesLoading}
                            refetch={refetchPackages}
                        />
                    </TabPanel>

                    <TabPanel value={tabValue} index={1}>
                        <ProductManagement
                            products={productsData?.getProducts || []}
                            loading={productsLoading}
                            refetch={refetchProducts}
                        />
                    </TabPanel>
                </Card>
            </Container>
        </>
    );
}
